// eslint-disable-next-line
export const ROOT_URL = process.env.PUBLIC_URL;